// Message limits
export const CHAT_MAX_FILES_PER_MESSAGE = 20;

// File type support
export const CHAT_SUPPORTED_IMAGE_TYPES = ['image/jpeg', 'image/jpg', 'image/png'];
export const CHAT_SUPPORTED_DOCUMENT_TYPES = ['application/pdf'];

// File size limits (applies to both images and documents)
export const CHAT_MAX_FILE_SIZE_BYTES = 8 * 1024 * 1024; // 8MB
export const CHAT_MAX_FILE_SIZE_MB = 8;

// Derived accept types for file input
export const CHAT_ACCEPT_TYPES = [...CHAT_SUPPORTED_IMAGE_TYPES, ...CHAT_SUPPORTED_DOCUMENT_TYPES].join(',');

// File type constants
export const CHAT_FILE_TYPE_IMAGE = 'image';
export const CHAT_FILE_TYPE_DOCUMENT = 'document';

// Image editing
export const CHAT_EDITED_IMAGE_FILENAME = 'edited-image.jpg';
export const CHAT_EDITED_IMAGE_TYPE = 'image/jpeg';

// Cropper settings
export const CHAT_CROPPER_INIT_TIMEOUT_MS = 100;
export const CHAT_CROPPER_MAX_WAIT_ATTEMPTS = 20;
export const CHAT_CROPPER_WAIT_INTERVAL_MS = 100;



// WEBPACK FOOTER //
// ./src/containers/ChatsPage/SingleChat/constants.ts